import { Component } from '@angular/core';

import { BaseComponent } from '@vivela/xplat/core';

@Component({
  selector: 'vivela-out-of-time',
  templateUrl: 'out-of-time.component.html',
})
export class OutOfTimeComponent extends BaseComponent {}
